import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import LivePlanBanner from "@/components/LivePlanBanner";
import { useAuthState } from "@/hooks/useAuthState";
import { canShowLiveActiveBanner } from "@/lib/livePlanAccess";

/**
 * Layout compartilhado de /minha-area: Navbar + banner do plano Live + conteúdo da rota.
 */
const MinhaAreaLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isAuthenticated,
    userType,
    userName,
    userPhoto,
    userId,
    user,
    subscriptionPlan,
    loading: authLoading,
  } = useAuthState();

  useEffect(() => {
    if (!authLoading && !isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [authLoading, isAuthenticated, navigate]);

  if (authLoading) {
    return (
      <div className="min-h-screen bg-background">
        <Navbar isAuthenticated={false} />
        <div className="container mx-auto px-4 py-8">
          <div className="flex items-center justify-center min-h-[400px]">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4" />
              <p className="text-muted-foreground">Verificando autenticação...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  const isAdminRoute = /\/admin(\/|$)/.test(location.pathname);
  const isMinhaAssinaturaRoute = /\/minha-assinatura\/?$/.test(location.pathname);
  const showLivePlanBanner =
    canShowLiveActiveBanner(userType, subscriptionPlan, user) &&
    !isAdminRoute &&
    !isMinhaAssinaturaRoute;

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <Navbar
        isAuthenticated={isAuthenticated}
        isOwner={userType === "owner"}
        userName={userName}
        userPhoto={userPhoto}
        userId={userId}
        userType={userType}
      />
      {showLivePlanBanner && (
        <div className="container mx-auto px-4 sm:px-6 max-w-6xl pt-4 pb-0">
          <LivePlanBanner userName={userName} />
        </div>
      )}
      <Outlet context={{ inMinhaAreaLayout: true }} />
    </div>
  );
};

export default MinhaAreaLayout;
